/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Asset update request
 */
export interface AssetUpdateRequest {
  id: number;
  name: string;
  /**
   * Disabled asset, can be used only with manual trade registration.
   */
  disabled: boolean;
  /**
   * Reference 1 unit price in USD.
   */
  refUsdPrice: number;
  /**
   * Scale balances in this asset, eg qtyScale = 2 -> step is 0.01.Only superadmin can change this value
   */
  qtyScale: number;
  /**
   * True if asset is fiat.
   */
  fiat?: boolean;
  /**
   * True if asset rate is setup manually.
   */
  manualRate?: boolean;
}
